import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Order Number"),
    /*#__PURE__*/_createElementVNode("th", null, "Item Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Item Quantity"),
    /*#__PURE__*/_createElementVNode("th", null, "Order Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Order Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Order By"),
    /*#__PURE__*/_createElementVNode("th", null, "Detail"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }

import { ref } from "vue";
import ShopServices from "../services/ShopServices";
import ShipOrder from "./OrderListComponents/ShipOrder.vue";
import CancelOrder from "./OrderListComponents/CancelOrder.vue";
import OrderDetail from "./OrderListComponents/OrderDetail.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'OrderList',
  setup(__props) {

const isLoading = ref(false);
const modalRef = ref<InstanceType<typeof ShipOrder>>();
const cancelModalRef = ref<InstanceType<typeof CancelOrder>>();
const detailModalRef = ref<InstanceType<typeof OrderDetail>>();

const shipOrder = async (item: any) => {
  modalRef.value?.show(item);
};
const cancelOrder = async (item: any) => {
  cancelModalRef.value?.show(item);
};
const orderDetail = async (item: any) => {
  detailModalRef.value?.show(item);
};
const data = ref([]);

const fetchData = async () => {
  isLoading.value = true;
  try {
    // const res = await ShopServices.getOrderList();
    // data.value = res.data;
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _hoisted_4,
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.orderId), 1),
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, _toDisplayString(item.quantity), 1),
                      _createElementVNode("td", null, _toDisplayString(item.date), 1),
                      _createElementVNode("td", null, _toDisplayString(item.status), 1),
                      _createElementVNode("td", null, _toDisplayString(item.customer?.name), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: ($event: any) => (orderDetail(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Detail")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          type: "success",
                          onClick: ($event: any) => (shipOrder(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Ship")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_button, {
                          type: "danger",
                          onClick: ($event: any) => (cancelOrder(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Cancel")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]))
        ])
      ])
    ]),
    _createVNode(ShipOrder, {
      ref_key: "modalRef",
      ref: modalRef,
      onSubmit: fetchData
    }, null, 512),
    _createVNode(CancelOrder, {
      ref_key: "cancelModalRef",
      ref: cancelModalRef,
      onSubmit: fetchData
    }, null, 512),
    _createVNode(OrderDetail, {
      ref_key: "detailModalRef",
      ref: detailModalRef
    }, null, 512)
  ], 64))
}
}

})